<div class="flex-vertical gap-32 width-100pc">
  <div class="flex-horizontal gap-16">
    <div>
      <oui-button type="icon" (click)="onBack()"><oui-icon>arrow_back</oui-icon></oui-button>
    </div>
    <div class="flex-vertical gap-4" *ngIf="headerCoA; else loading">
      <div class="subtitle-2 color-on-surface-medium">
        {{
          headerCoA.coa?.enveloppe?.libelle +
            ' - ' +
            (headerCoA.coa?.typeInvestisseur | investisseurType) +
            ' - ' +
            headerCoA.coa?.natureOperation?.libelle
        }}
      </div>

      <div class="flex-horizontal flex-center gap-16">
        <oui-tag type="status" declination="secondary" status="completed" size="big">Digitale</oui-tag>
        <h6>{{ headerCoA.libelle }}</h6>
      </div>
      <div class="caption color-on-surface-medium">Dernière mise à jour le {{ headerCoA.lastUpdate }}</div>
    </div>
    <div class="flex-1"></div>
    <oui-button type="contained" (click)="onAddVersion()">Ajouter une version</oui-button>
  </div>

  <div class="flex-vertical oui-elevation-04 background-white rounded width-100pc padding-24 gap-40">
    <app-fiche-config-table
      [inputData]="requestResult"
      (requestNewPage)="fetchAllConfigs()"
      [columnSelection]="columnSelection"
      [displayedColumns]="displayedColumns"
      (onRowClick)="onConfigClick($event)">
    </app-fiche-config-table>
  </div>
</div>
<ng-template #loading>
  <div>
    <oui-loading class="flex-horizontal flex-center justify-center"></oui-loading>
  </div>
</ng-template>
